import { ResetAlt } from '@mint-lib/icons';
import { Link as RouterLink } from '@mint/routing';

import { useImportHubPaths } from '../../hooks/useImportHubRouteApi.js';

export const DataFileLink = ({
  dataFileId,
  children,
}: {
  dataFileId: string;
  children: React.ReactNode;
}) => {
  const paths = useImportHubPaths();

  return (
    <RouterLink
      to={paths.dataFile}
      params={{ dataFileId }}
      preload="render"
      preloadDelay={0}
      data-dd-action-name="Resume import"
      className="flex h-full items-center gap-2 whitespace-nowrap"
    >
      <ResetAlt />
      {children}
    </RouterLink>
  );
};
